import { useEffect, useRef, useState } from 'react';
import {
  useMotionValue,
  useTransform,
  animate,
  useInView,
  useReducedMotion,
} from 'framer-motion';

/**
 * CountUp. Animates a number from 0 to target once when it enters the viewport.
 * Respects prefers-reduced-motion (shows the target immediately).
 */
export default function CountUp({
  target,
  prefix = '',
  suffix = '',
  duration = 1.4,
  className = '',
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  const mv = useMotionValue(0);
  const rounded = useTransform(mv, (v) => Math.floor(v));
  const [val, setVal] = useState(0);
  const reduce = useReducedMotion();

  useEffect(() => {
    if (!inView) return;
    if (reduce) {
      setVal(target);
      return;
    }
    const controls = animate(mv, target, {
      duration,
      ease: [0.22, 1, 0.36, 1],
    });
    const unsub = rounded.on('change', (v) => setVal(v));
    return () => {
      controls.stop();
      unsub();
    };
  }, [inView, target, reduce, duration, mv, rounded]);

  return (
    <span ref={ref} className={`tabular-nums ${className}`}>
      {prefix}
      {val}
      {suffix}
    </span>
  );
}
